import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';

import { RegistrationAddress } from '../../models/registrationaddress';

/**
 * Generated class for the UpdateRegistrationAddress2Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-address2',
  templateUrl: 'update-registration-address2.html',
})
export class UpdateRegistrationAddress2Page {

  private user: any;
  public registrationAddress: RegistrationAddress;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider
  ) {
    this.registrationAddress = new RegistrationAddress();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationAddress2Page');
  }

  ionViewWillEnter() {
    this.user = this.navParams.get('user');
    this.registrationAddress = this.navParams.get('registrationAddress');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o endereço.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.address)) {
      this.alertProvider.doAlert('Forneça o endereço.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.addressNumber)) {
      this.alertProvider.doAlert('Forneça o número.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.addressCountry)) {
      this.alertProvider.doAlert('Forneça o bairro.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu endereço?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updateAddress(that.registrationAddress).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seu endereço foi salvo com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
            that.user.address = that.registrationAddress.address;
            that.user.addressNumber = that.registrationAddress.addressNumber;
            that.user.addressComplement = that.registrationAddress.addressComplement;
            that.user.addressCountry = that.registrationAddress.addressCountry;
            that.user.addressCity = that.registrationAddress.addressCity;
            that.user.addressState = that.registrationAddress.addressState;
            that.user.addressZip = that.registrationAddress.addressZip;

            that.authProvider.setUser(that.user);
            that.eventEmitterProvider.get('registration_updated').emit(that.user);

            // that.onBack();
            // It needs to back two pages
            // this.navCtrl.pop({
            //   animation: 'ios-transition'
            // }).then(() => {
            //   this.navCtrl.pop({
            //     animation: 'ios-transition'
            //   });
            // })
            that.navCtrl.remove(that.navCtrl.getActive().index - 1, 2, {
              animation: 'ios-transition'
            });
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-address2/update-registration-address2.ts